<template>
  <div role="list">
    <div
      v-for="(listingItem, index) in searchResult.listings"
      :key="`list-item-${listingItem.id}`"
      :class="$style.listItem"
      role="listitem"
    >
      <ListCard :index="index" :listingItem="listingItem" @onListCardClick="trackItemClicked" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { HgListingCardSize } from '@smg-real-estate/domus';
import { ListingItem, SearchResult } from '@smg-real-estate/hg-search-libs';

import { GTMPageType } from '@/helpers/GTM/GTMParameters';

import ListCard from '@/components/ListCard/ListCard.vue';
import { trackSearchClickThrough } from '@/components/ResultList/ResultList.tracking';

export interface Props {
  searchResult: SearchResult;
  gtmPageType: GTMPageType;
}

const props = defineProps<Props>();

const trackItemClicked = ({
  listingItem,
  index,
  listingCardSize,
}: {
  listingItem: ListingItem;
  index: number;
  listingCardSize: HgListingCardSize;
}): void => {
  const { page, itemsPerPage } = props.searchResult;
  const positionOnPage = index + 1;
  const positionOverall = (page - 1) * itemsPerPage + positionOnPage;
  // NOTE: convert HgListingCardSize to string for tracking
  const cardSize =
    Object.keys(HgListingCardSize)[Object.values(HgListingCardSize).indexOf(listingCardSize)];

  trackSearchClickThrough({
    listingItem,
    positionOverall,
    gtmPageType: props.gtmPageType,
    listingCardSize: cardSize,
  });
};
</script>

<style lang="scss" module>
@import '@/assets/variables';

.listItem {
  padding-top: $space-100;
  padding-bottom: $space-100;
}

.notificationToast > div {
  z-index: 1000;
}
</style>
